import Axios from '@/plugins/Axios';

import { CheckoutSubscriptionPayload } from '@/types';

const endpoint = '/checkout';

const checkOutApi = {
  checkoutSubscription: (data: CheckoutSubscriptionPayload) => {
    return Axios().post(`${endpoint}`, data);
  },
};

export default checkOutApi;
